import { createFileRoute, notFound } from "@tanstack/react-router";

import { TravelDiseaseIndexView } from "@/components/pages/TravelDiseaseView";
import { meta } from "@/content/meta";
import { isLocale } from "@/i18n/locales";
import { seoHead } from "@/lib/site";

export const Route = createFileRoute("/$locale/travel/diseases/")({
  head: ({ params }) =>
    isLocale(params.locale)
      ? seoHead({
          locale: params.locale,
          path: "/travel/diseases",
          ...meta[params.locale].travelDiseases,
        })
      : {},
  component: TravelDiseasesIndexRoute,
});

function TravelDiseasesIndexRoute() {
  const { locale } = Route.useParams();
  if (!isLocale(locale)) throw notFound();
  return <TravelDiseaseIndexView locale={locale} />;
}
